export function calculateWrapAroundIndex(dataLength: number, index: number): number {
  return (dataLength + index % dataLength) % dataLength;
}

export function calculateWrapAroundDistance(dataLength: number, firstIndex: number, secondIndex: number): number {
  const distanceStraight = Math.abs(firstIndex - secondIndex);
  const distanceAround = dataLength - 1 - distanceStraight;
  return Math.min(distanceStraight, distanceAround);
}
